var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-chip',{staticClass:"border additional-benefits",attrs:{"isMinimal":true},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('div',[_vm._v("+"+_vm._s(_vm.remainingItemsCount))])]},proxy:true}])},[_vm._v(_vm._s(` ${_vm.chipText}`))])
}
var staticRenderFns = []

export { render, staticRenderFns }